import { TaskTypes } from 'src/app/shared/models/tasks.model';
import {
  SidebarTabs,
  TaskOwnership,
  TaskOwnershipType,
} from '../../model/sidebar.model';

export interface ISidebarState {
  searchString: string;
  taskTypesSelection: TaskTypes[];
  taskOwnership: TaskOwnership;
  activeTab: SidebarTabs;
  collapsed: boolean;
}

export class SidebarStateObject implements ISidebarState {
  searchString: string;
  taskTypesSelection: TaskTypes[];
  taskOwnership: TaskOwnership;
  activeTab: SidebarTabs;
  collapsed: boolean;

  constructor(state: ISidebarState) {
    this.searchString = state.searchString;
    this.taskTypesSelection = state.taskTypesSelection;
    this.taskOwnership = state.taskOwnership;
    this.activeTab = state.activeTab;
    this.collapsed = state.collapsed;
  }
}

export const defaultSidebarState: ISidebarState = {
  searchString: '',
  taskTypesSelection: [],
  taskOwnership: TaskOwnershipType.My,
  activeTab: SidebarTabs.OpenTasks,
  collapsed: false,
};
